// 20250707: grk update old actions/profile.js
//           set details here to fix inconsistency that was in old cde
export const SET_PROFILE = 'SET_PROFILE';
export const AUTH_CALLED = 'AUTH_CALLED';

// export const setProfile = (details, error = null) => ({
//   type: SET_PROFILE,
//   payload: { details, error }
// });

export const setProfile = (profile, error = null) => ({
  type: SET_PROFILE,
  payload: { ...profile, error }  // spread profile fields directly in payload
});

export const authCalled = () => ({
  type: AUTH_CALLED
});